import { render, staticRenderFns } from "./SkillModal.vue?vue&type=template&id=531c30d0&scoped=true"
import script from "./SkillModal.vue?vue&type=script&lang=js"
export * from "./SkillModal.vue?vue&type=script&lang=js"
import style0 from "./SkillModal.vue?vue&type=style&index=0&id=531c30d0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531c30d0",
  null
  
)

export default component.exports